<template>
  <div class="mod Enterprise" :class="{'isEn': isEn}">
    <div class="top-banner">
      <span class="about-label banner-txt-con" :style="{ left: `${left}px` }">
        {{ $t('culture-banner-txt1') }}
        <span> {{ $t('culture-banner-txt2') }}</span>
      </span>
      <!-- <img src="@/assets/img/Enterprise.png" @load="bannerloadEvent" /> -->
    </div>
    <div class="linkBox" id="EnterpriseTop">
      <div class="link-tab">
        <div @click="tabEvent(0, 'EnterPriseone',-130)" :class="btnActiveIndex === 0 ? 'link-btn link-btn-active' : 'link-btn'"> {{ $t('culture-btn-txt1') }}
        </div>
        <div @click="tabEvent(1, 'EnterPrisetwo',-200)" :class="btnActiveIndex === 1 ? 'link-btn link-btn-active' : 'link-btn'">{{ $t('culture-btn-txt2') }}
        </div>
        <div @click="tabEvent(2, 'EnterPrisethree',-200)" :class="btnActiveIndex === 2 ? 'link-btn link-btn-active' : 'link-btn'">{{ $t('culture-btn-txt3') }}
        </div>
        <div @click="tabEvent(3, 'EnterPrisefour')" :class="btnActiveIndex === 3 ? 'link-btn link-btn-active' : 'link-btn'">{{ $t('culture-btn-txt4') }}
        </div>
        <div @click="tabEvent(4, 'EnterPrisefive',-110)" :class="btnActiveIndex === 4 ? 'link-btn link-btn-active' : 'link-btn'">{{ $t('culture-btn-txt5') }}
        </div>
      </div>
    </div>


    <!-- <div class="body">
      <div class="block1">
        <div class="labelWrapper"><span class="label">企业文化</span></div>
        <div class="container1">
          <span class="wordItem0">工作理念</span>
          <span class="wordItem1">福利激励</span>
          <span class="wordItem2">加入康霖</span>
          <span class="wordItem3">团队风采</span>
        </div>
      </div>
    </div> -->
    <div class="submain zoomCenterTop" id="EnterPriseone">
      <div class="block2">
        <div class="titleWrapper"><span class="title1">{{ $t('culture-btn-txt1') }}</span></div>
        <div class="wrapperEnterP-part1">
          <div class="wrapper1">
            <div class="groupItem0">
              <div class="enterp-part1-title">{{ $t('culture-part1-t1') }}</div>
              <div class="enterp-part1-desc">{{ $t('culture-part1-txt1') }}</div>
            </div>
            <div class="groupItem0">
              <div class="enterp-part1-title">{{ $t('culture-part1-t2') }}</div>
              <div class="enterp-part1-desc">{{ $t('culture-part1-txt2') }}</div>
            </div>
            <div class="groupItem0">
              <div class="enterp-part1-title">{{ $t('culture-part1-t3') }}</div>
              <div class="enterp-part1-desc">{{ $t('culture-part1-txt3') }}</div>
            </div>
            <!-- <div class="groupItem1">
              <span class="company">{{ $t('culture-part1-t2') }}</span>
              <span class="summary">{{ $t('culture-part1-txt2') }}</span>
            </div>
            <div class="groupItem2" :class="{'en':isEn}">
              <span class="caption1">{{ $t('culture-part1-t3') }}</span>
              <span class="desc1">{{ $t('culture-part1-txt3') }}</span>
            </div> -->
          </div>
          <img class="entPcover2" src="@/assets/img/enterprise/images/img_11.webp" />
        </div>
      </div>
    </div>
    <div id="EnterPrisetwo" class="zoomLeftTop">
      <div class="row">
        <div class="block3">
          <div class="titleWrapper1"><span class="title2">{{ $t('culture-btn-txt2') }}</span></div>
          <div class="grid">
            <div class="colItem0">
              <div class="wordWrapper"><span class="word">{{ $t('culture-part2-t1') }}</span></div>
              <span class="detail">{{ $t('culture-part2-txt1') }}</span>
            </div>
            <div class="colItem1">
              <div class="tagWrapper"><span class="tag1">{{ $t('culture-part2-t2') }}</span></div>
              <span class="detail1">{{ $t('culture-part2-txt2') }}</span>
            </div>
            <div class="colItem2">
              <div class="organizationWrapper">
                <span class="organization">{{ $t('culture-part2-t3') }}</span>
              </div>
              <span class="detail2">{{ $t('culture-part2-txt3') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row1 zoomCenterTop" id="EnterPrisethree">
      <div class="block4">
        <div class="captionWrapper"><span class="caption2">{{ $t('culture-btn-txt3') }}</span></div>
        <div class="container3">
          <div class="wrapper2">
            <div class="group1" :class="{'en':isEn}">
              <span class="word1 span" :class="{ active: fuliIndex === 0 }" @click="fuliEvent(0)">{{ $t('culture-part3-t1') }}</span>
              <span class="span label1" :class="{ active: fuliIndex === 1 }" @click="fuliEvent(1)">{{ $t('culture-part3-t2') }}</span>
              <span class="span word1" :class="{ active: fuliIndex === 2 }" @click="fuliEvent(2)">{{ $t('culture-part3-t3') }}</span>
            </div>
            <template v-for="(item, index) in fuliList">
              <div key="index" :class="'item' + index" class="itemBox" v-if="index === fuliIndex">
                <span class="article">{{ $t(item.name) }}</span>
              
                <div class="groupItem01" :class="{'en':isEn}" v-if="index === 0">
                  <span >  
                      {{$t('culture-part3-t1-i1')}}</span>
                  
                    <span >
                      {{$t('culture-part3-t1-i2')}}
                    </span>
                 
                  <span >{{$t('culture-part3-t1-i3')}}</span>
                  <span >{{$t('culture-part3-t1-i11')}}</span>


                
                 
                  <span >{{$t('culture-part3-t1-i5')}}</span>
                 

                  <span >
                   
                    {{$t('culture-part3-t1-i6')}}</span>
                 
                  <span  >
                    {{$t('culture-part3-t1-i7')}}</span>

                    <span > 
                    {{$t('culture-part3-t1-i8')}}</span>
                  
                  <span >
                    {{$t('culture-part3-t1-i9')}}</span>
                
                  <span >
                    {{$t('culture-part3-t1-i10')}}</span>
                    <span :class="{'en':isEn}">  {{$t('culture-part3-t1-i4')}}</span>
                </div>
              
              </div>
            </template>
          </div>
          <img class="entPcover3" src="@/assets/img/enterprise/images/img_23.webp" />
        </div>
      </div>
    </div>
    <div class="row2 zoomCenterTop" id="EnterPrisefour">
      <div class="block5">
        <div class="block5_box">
          <span class="organization1">{{$t('culture-part4-txt1')}}</span>
          <div class="container4">
            <div class="tagWrapper1 buttonhover" @click="join()"><span class="tag6">{{$t('culture-btn-txt4')}}</span></div>
          </div>
        </div>
        <div id="swiper-container-honor" class="swiper-container">
          <div class="container5 swiper-wrapper">
            <div class="wrapper4 swiper-slide">
              <div class="slide-con">
                <div class="group3 people2">
                  <span class="name1 ">{{$t('peoplehuyin')}}</span>
                  <!-- <span class="nickName1">毕业于扬州大学</span> -->
                </div>
                <div class="content">
                  {{$t('culture-part4-txt1')}}
                  {{$t('peoplehuyin1')}} 
                </div>
            </div>
            </div>
            <div class="wrapper4 swiper-slide">
              <div class="slide-con">
                <div class="group3 people1">
                  <span class="name1"> {{$t('peoplechenxi')}}</span>
                  <!-- <span class="nickName1">毕业于浙江大学</span> -->
                </div>
                <div class="content">
                  {{$t('peoplechenxi1')}}
                </div>
             </div>
            </div>
            <div class="wrapper4 swiper-slide">
              <div class="slide-con">
                <div class="group3 people3">
                  <span class="name1">{{$t('peoplepingguo')}}</span>
                  <!-- <span class="nickName1">毕业于兰州大学</span> -->
                </div>
                <div class="content">
                  {{$t('peoplepingguo1')}}
                </div>
              </div>
            </div>

            <div class="wrapper4 swiper-slide">
              <div class="slide-con">
                <div class="group3 people10">
                  <span class="name1">{{$t('peoplepxiaofanqie')}}</span>
                  <!-- <span class="nickName1">毕业于中国计量大学</span> -->
                </div>
                <div class="content">
                  {{$t('peoplepxiaofanqie1')}}
                </div>
              </div>
            </div>

            <div class="wrapper4 swiper-slide">
              <div class="slide-con">
                <div class="group3 people4">
                  <span class="name1">{{$t('peoplepingguoxuxu')}}</span>
                  <!-- <span class="nickName1">毕业于四川轻化工大学</span> -->
                </div>
                <div class="content">
                  {{$t('peoplepingguoxuxu1')}}
                </div>
              </div>
            </div>
            <div class="wrapper4 swiper-slide">
              <div class="slide-con">
              <div class="group3 people5">
                <span class="name1">{{$t('peoplepingguofeifei')}}</span>
                <!-- <span class="nickName1">毕业于杭州师范大学</span> -->
              </div>
              <div class="content">
                {{$t('peoplepingguofeifei1')}}
              </div>
            </div>
            </div>
            <div class="wrapper4 swiper-slide">
              <div class="slide-con">
              <div class="group3 people6">
                <span class="name1">{{$t('peoplepingguoxiangd')}}</span>
                <!-- <span class="nickName1">毕业于扬州大学</span> -->
              </div>
              <div class="content">
                {{$t('peoplepingguoxiangd1')}}

              </div>
            </div>
            </div>
            <div class="wrapper4 swiper-slide">
              <div class="slide-con">
                <div class="group3 people9">
                  <span class="name1">{{$t('peoplepingguored')}}</span>
                  <!-- <span class="nickName1">毕业于长江大学</span> -->
                </div>
                <div class="content">
                  {{$t('peoplepingguored1')}}
                </div>
              </div>
            </div>

            <div class="wrapper4 swiper-slide">
              <div class="slide-con">
                <div class="group3 people7">
                  <span class="name1">{{$t('peoplepingguoxuwq')}}</span>
                  <!-- <span class="nickName1">毕业于浙江经贸大学</span> -->
                </div>
                <div class="content">
                  {{$t('peoplepingguoxuwq1')}}
                </div>
              </div>
            </div>

          </div>
          <div class="swiper-pagination swp-pagination-honor"></div>
        </div>
      </div>
    </div>
    <div class="main zoomCenterTop" id="EnterPrisefive">
      <div class="titleWrapper2"><span class="title3">{{$t('culture-btn-txt5')}}</span></div>
      <div class="block6">
        <!-- <img class="icon11" src="@/assets/img/enterprise/images/left_blue_arr.png" @click="teamEvent('left')" /> -->
        <div class="imgBox1 swiper-container">
          <div class="imgBox swiper-wrapper">
            <img class="swiper-slide" :class="{ banner1: index === 0 }" v-for="(item, index) in imglist" :src="item" :key="index + item" />
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <!-- <img class="icon12" src="@/assets/img/enterprise/images/right_blue_arr.png" @click="teamEvent('right')" /> -->
      </div>
    </div>
  </div>
</template>
<script>


import { menuFixed } from '@/utils/index'
import { WOW } from 'wowjs';
import Swiper from "swiper";

export default {
  components: {

  },
  data () {
    return {
      isEn:localStorage.getItem("lang") === 'EN',
      left: '',
      constants: {},
      show: true,
      btnActiveIndex: 0,

      fuliList: [{
        name: 'culture-part3-txt1',
      },
      {
        name: 'culture-part3-txt2-1',
      }, {
        name: 'culture-part3-txt3',
      }
      ],

      data: [
        {
          title: '',
          name: ''
        },
        {
          title: '“人生最幸福的事情就是和一群志同道合的朋友，在最该努力的年纪，为同一个梦想努力拼搏，充分实现自我价值。很多人加入康霖，是被公司愿景和情怀所打动的。为患者做好药，创新造就价值，这是康霖一贯秉承的发展理念。康霖人将以坚定不移的信念，深耕基因治疗领域，解决未被满足的临床需求，实现功能性治愈各类疾病的愿景。”',
          name: '朱旭东'
        }, {
          title: '',
          name: ''
        }
      ],
      imglist: [
        require('@/assets/img/enterprise/images/img_1.webp'),
        require('@/assets/img/enterprise/images/img_2.webp'),
        require('@/assets/img/enterprise/images/img_3.webp'),
        require('@/assets/img/enterprise/images/img_4.webp'),
        require('@/assets/img/enterprise/images/img_5.webp'),
        require('@/assets/img/enterprise/images/img_6.webp'),
        require('@/assets/img/enterprise/images/img_7.webp'),
      ],
      fuliIndex: 0
    }
  },
  methods: {
    bannerloadEvent () {
      this.left = $('.header-nav').offset() && $('.header-nav').offset().left + 74 - $('.top-banner').offset().left
    },
    fuliEvent (index) {
      this.fuliIndex = index
    },
    join () {
      this.$router.push({
        path: '/join'
      })
    },
    tabEvent (index, id, num= 0) {
      this.btnActiveIndex = index
      let isfixed = $('.linkBox').css('position') === 'fixed'
      let offset = index == 0 && isfixed ? 65 : 0
      if(!isfixed && index!==0){
        offset -= 65
      }
      const top = $('#' + id).offset().top - 134 + offset - num
      console.log(top)
      $("html,body").animate({ scrollTop: top }, 500);
    },
    clickEvent (type) {
      let _data = []
      let data = this.data
      if (type === 'left') {
        _data[0] = data[1]
        _data[1] = data[2]
        _data[2] = data[0]
      } else {
        _data[1] = data[0]
        _data[2] = data[1]
        _data[0] = data[2]
      }
      this.data = _data
    },
    swiperEvent () {
      var swiper = new Swiper('.swiper-container.imgBox1', {
        direction: "horizontal",
        initialSlide: 1,
        slidesPerView: "auto",
        width:300,
        centeredSlides: true,
        autoplay: 8000,
        speed: 600,
        slidesOffsetBefore:120,
        loop: true,
        autoplay: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        autoplayDisableOnInteraction: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        paginationClickable: true,
      });
    },
    teamEvent (type) {
      if (type === 'left') {
        // let width =  $('.imgBox img').eq(0).width() 
        // $('.imgBox').animate({left: -width}, 3000);
        let arrone = this.imglist.shift()
        this.imglist.push(arrone)
      } else {
        let arrlast = this.imglist.pop()
        this.imglist.unshift(arrlast)
      }
    },

    onScrollSwitchTabEnt(){
      var that = this
      window.addEventListener('scroll', function () {
        var tarElArr = [$("#EnterPriseone"), $("#EnterPrisetwo"), $("#EnterPrisethree"), $("#EnterPrisefour"), $("#EnterPrisefive")]
        var tarElScrollArr = [tarElArr[0].offset().top - 110, 
        tarElArr[1].offset().top - 110,
         tarElArr[2].offset().top - 110,
         tarElArr[3].offset().top -150,
         tarElArr[4].offset().top - 130
        ] 
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        console.log(scrollTop)
        if (scrollTop >= 0 && scrollTop <= tarElScrollArr[0]) {
          that.btnActiveIndex = 0

        }
        else if (tarElScrollArr[0] < scrollTop && scrollTop <= tarElScrollArr[1]) {
          that.btnActiveIndex = 0
        } else if (tarElScrollArr[1] < scrollTop && scrollTop <= tarElScrollArr[2]) {
          that.btnActiveIndex = 1
        }
        else if (tarElScrollArr[2] < scrollTop && scrollTop <= tarElScrollArr[3]) {
          that.btnActiveIndex = 2
        }
        else if (tarElScrollArr[3] < scrollTop && scrollTop <= tarElScrollArr[4]) {
          that.btnActiveIndex = 3
        }
         else  {
          that.btnActiveIndex = 4
        } 

        console.log('this.btnActiveIndex'+ that.btnActiveIndex)
    })
    },

  },
  mounted () {
    // 滚动到顶部固定
    menuFixed()
    setTimeout(() => {
      this.left = $('.header-nav').offset() && $('.header-nav').offset().left + 74 - $('.top-banner').offset().left
    }, 100)

    setTimeout(() => {
      var swiper = new Swiper('#swiper-container-honor', {
        direction: 'vertical',
        loop: true,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 500,
          modifier: 1,
          slideShadows: true,
        },
        pagination: {
          el: '.swp-pagination-honor',
        },
        grabCursor: true,//开启鼠标手指拖动
        autoplay: true
      });
      this.swiperEvent()
    }, 10)

    this.$nextTick(() => {
      new WOW().init();
      this.bannerloadEvent()
      this.onScrollSwitchTabEnt()
    })

    
  }

}
</script>

<style lang="less">
.Enterprise {

  .top-banner{
      width: 100%;
      background: url(../../assets/img/webp/Enterprise.webp) no-repeat top;
      background-size: cover;
  }
  .block5 {
    .swiper-container{
      position:relative;
      // top:-20px;
    }
    .swiper-container-vertical>.swiper-pagination-bullets {
      left: 26px
    }

    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background: #FFFFFF !important
    }

    .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
      margin: 12px 0;
    }

    .swiper-slide{
      opacity:0.1
    }

    .swiper-slide-next,
    .swiper-slide.swiper-slide-prev {
      transform: none !important;
      opacity: 0.6;
      margin-top: 30px;
      border-radius: 20px;
    }
    
    .wrapper4.swiper-slide-active.swiper-slide{
      opacity:1
    }

    .swiper-slide-shadow-top,
    .swiper-slide-shadow-bottom {
      border-radius: 20px;
      // display:none;
    }

  }
  .grid {
    .word,
    .tag1,
    .organization {
      padding-bottom: 12px;
      border-bottom: 4px solid #2DB3D0;
    }

    .detail,
    .detail1,
    .detail2 {
      margin: 24px 0 0 27px !important
    }
  }
}
#five{
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #2DB3D0;
  }
  .swiper-pagination-bullet{
    background: #2DB3D0 !important;
  }
  .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets{
    bottom: -2px;
  }
}

</style>

<style lang="less" scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
  /*点击按钮页面即将被显示，此时div标签处于隐藏状态*/
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
  /* 对该CSS样式进行transition的监控,有3s的过渡*/
}


.itemBox {
  margin: 30px 120px 0 0
}
.isEn {
  .itemBox{
    margin-top:15px;
  }
}


.wrapper2 .span {
  padding-bottom: 20px !important
}

.wrapper2 .active {
  border-bottom: 2px solid #2DB3D0;
  color: #2DB3D0 !important;
}

.item0 {
  img.iconItem0 {
    bottom: 128px
  }

  img.iconItem1 {
    bottom: 80px
  }

  img.iconItem2 {
    bottom: 28px
  }
}

.item1 {
  img.iconItem0 {
    bottom: 68px
  }

  img.iconItem1 {
    bottom: 19px
  }

  img.iconItem2 {
    bottom: -32px
  }
}

.item2 {
  img.iconItem0 {
    bottom: 158px
  }

  img.iconItem1 {
    bottom: 109px
  }

  img.iconItem2 {
    bottom: 60px
  }
}

.groupItem01 {
  width: 586px;
  display: flex;
  /* margin: 30px 0 0 30px; */
  /* justify-content: space-between; */
  align-self: center;
  position: relative;
  margin-top: 30px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  &:first-child{
   
  }
  span{
    display: block; 
    background: url('../../assets/img/prefecture/images/img_11.svg') no-repeat;
    background-size: 24px;
    background-position: 0 3px;
    width: 130px;
    line-height: 30px;
    padding-left: 32px;
    font-size: 14px;
    color: #000;
    margin-bottom: 20px;
    
  }
  &.en{
    span{
      width: 187px;
      &:last-child{
        width: 232px;
      }
    }
  }
}


/* .swiper-container .swiper-wrapper{
  -webkit-transition-timing-function: linear;
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
} */

.block5_box{
  margin-left: 82px;
  width: 590px;
  text-align: left;
  margin-top: 200px;
}


.mod {
  background-color: rgba(255, 255, 255, 1);
  background-image: url(../../assets//img/enterprise/images/img_38.png),
    url(../../assets/img/enterprise/images/img_39.png);
  background-repeat: no-repeat, no-repeat;
  background-position: 1335px 5075px, 1347px 4982px;
  background-size: 22px 7px, 9px 9px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom:100px;
}
.mod .header {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1440px;
}
.mod .block {
  height: 650px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: flex-start;
  padding: 17px 12px 228px;
  background-image: url(../../assets/img/enterprise/images/img_40.png);
  background-repeat: no-repeat;
  background-position: 0px 0px;
  background-size: 100% 100%;
  background-origin: padding-box;
}
.mod .container {
  align-self: center;
  position: relative;
  width: 1278px;
  height: 48px;
}
.mod .empty {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 5;
  width: 130px;
  height: 48px;
}
.mod .empty1 {
  position: absolute;
  left: 50%;
  bottom: 7px;
  z-index: 3;
  width: 788px;
  height: 26px;
  transform: translateX(-50%);
}
.mod .empty2 {
  position: absolute;
  right: 70px;
  bottom: 7px;
  z-index: 0;
  width: 42px;
  height: 26px;
}
.mod .wrapper {
  position: absolute;
  display: flex;
  justify-content: space-between;
  left: 50%;
  top: 0px;
  z-index: 1;
  width: 1277px;
  transform: translateX(-50%);
}
.mod .logo {
  width: 130px;
  height: 48px;
  align-self: center;
}
.mod .logoItem0 {
  width: 92px;
  height: 26px;
  position: absolute;
  left: 245px;
  bottom: 7px;
}
.mod .logoItem1 {
  width: 92px;
  height: 26px;
  position: absolute;
  left: 361px;
  bottom: 7px;
}
.mod .logoItem2 {
  width: 92px;
  height: 26px;
  position: absolute;
  left: 477px;
  bottom: 7px;
}
.mod .logoItem3 {
  width: 92px;
  height: 26px;
  position: absolute;
  bottom: 7px;
  left: 50%;
  transform: translateX(-50%);
}
.mod .logoItem4 {
  width: 92px;
  height: 26px;
  position: absolute;
  right: 476px;
  bottom: 7px;
}
.mod .logoItem5 {
  width: 92px;
  height: 26px;
  position: absolute;
  right: 360px;
  bottom: 7px;
}
.mod .logoItem6 {
  width: 92px;
  height: 26px;
  position: absolute;
  right: 244px;
  bottom: 7px;
}
.mod .group {
  display: flex;
  margin-right: 18px;
  justify-content: flex-start;
  align-self: center;
  height: 48px;
  width: 226px;
  padding: 15px 0 7px;
}
.mod .tag {
  color: rgba(255, 255, 255, 1);
  font-size: 18px;

  line-height: 26px;
  margin-left: 133px;
  align-self: flex-end;
  white-space: nowrap;
  text-transform: uppercase;
}
.mod .dot {
  width: 11px;
  height: 6px;
  align-self: flex-end;
  margin: 0 0 10px 6px;
}
.mod .icon {
  width: 17px;
  height: 17px;
  position: absolute;
  right: 1px;
  bottom: 12px;
}
.mod .dot1 {
  width: 1px;
  height: 1px;
  position: absolute;
  right: 0px;
  bottom: 11px;
}
.mod .empty3 {
  position: absolute;
  right: 1px;
  bottom: 11px;
  z-index: 2;
  width: 18px;
  height: 18px;
}
.mod .title {
  color: rgba(255, 255, 255, 1);
  font-size: 70px;

  line-height: 98px;
  text-align: left;
  align-self: flex-start;
  width: 770px;
  height: 196px;
  overflow: hidden;
  text-overflow: ellipsis;
  webkit-line-clamp: 2;
  webkit-box-orient: vertical;
  white-space: normal;
  margin: 161px 0 0 69px;
}
.mod .body {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 100%;
  background-color: #f3f9fa;
}
.mod .block1 {
  background-color: #f3f9fa;
  display: flex;
  justify-content: flex-start;
  align-self: flex-start;
  width: 1440px;
  padding: 0 12px;
  margin: 0 auto;
}
.mod .labelWrapper {
  background-color: #ffffff;
  display: flex;
  margin-left: 70px;
  justify-content: center;
  align-self: center;
  width: 150px;
  padding: 20px 12px 19px;
}
.mod .label {
  color: rgba(45, 179, 208, 1);
  font-size: 18px;

  line-height: 26px;
  align-self: flex-start;
  max-width: 126px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .container1 {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  height: 65px;
  width: 1196px;
  padding: 20px 0 19px;
}
.mod .wordItem0 {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;

  line-height: 26px;
  margin-left: 79px;
  align-self: center;
  white-space: nowrap;
}
.mod .wordItem1 {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;

  line-height: 26px;
  margin-left: 118px;
  align-self: center;
  white-space: nowrap;
}
.mod .wordItem2 {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;

  line-height: 26px;
  margin-left: 118px;
  align-self: center;
  white-space: nowrap;
}
.mod .wordItem3 {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;

  line-height: 26px;
  margin-left: 118px;
  align-self: center;
  white-space: nowrap;
}
.mod .submain {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1440px;
}
.mod .block2 {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: flex-start;
  width: 1440px;
  padding: 120px 12px;
}
.mod .titleWrapper {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1278px;
}
.mod .title1 {
  color: rgba(0, 0, 0, 1);
  font-size: 40px;

  line-height: 56px;
  align-self: flex-start;
  max-width: 1278px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .container2 {
  display: flex;
  margin-top: 60px;
  justify-content: flex-start;
  align-self: center;
  width: 1278px;
}
.mod .wrapper1 {
  /* display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: center; */
  height: 460px;
  // width: 649px;
}
.mod .wrapperEnterP-part1 {
  /*
  flex-direction: column;
  justify-content: flex-start;
  align-self: center; */
  // width: 649px;
  display: flex;
  justify-content: space-between;
  width: 1278px;
  margin: 58px auto 0;
}
.mod .groupItem0 {
  width: 520px;
  margin-bottom: 58px;
  .enterp-part1-title{
    color: #2db3d0;
    font-size: 30px;
    line-height: 30px;
  }
  .enterp-part1-desc{
    color: #000000;
    font-size: 16px;
    line-height: 30px;
    margin-top: 17px;
    opacity: 0.6;
  }
}
.mod .caption {
  color: rgba(45, 179, 208, 1);
  font-size: 30px;

  line-height: 30px;
  align-self: flex-start;
  max-width: 649px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .desc {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;

  line-height: 16px;
  margin-top: 29px;
  align-self: flex-start;
 width: 649px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .groupItem1 {
  width: 649px;
  height: 112px;
  display: flex;
  flex-direction: column;
  margin-top: 73px;
  justify-content: flex-start;
  align-self: center;
}
.mod .company {
  color: rgba(45, 179, 208, 1);
  font-size: 30px;

  line-height: 30px;
  align-self: flex-start;
  max-width: 649px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .summary {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;

  line-height: 30px;
  margin-top: 22px;
  align-self: flex-start;
  width: 512px;
  height: 60px;
  /* overflow: hidden; */
  text-overflow: ellipsis;
  webkit-line-clamp: 2;
  webkit-box-orient: vertical;
  white-space: normal;
}
.mod .groupItem2 {
  width: 618px;
  height: 75px;
  display: flex;
  flex-direction: column;
  margin-top: 66px;
  justify-content: flex-start;
  align-self: center;
  &.en{
    height: 113px;
    .desc1{
      line-height: 1.5;
    }
  }

}
.mod .caption1 {
  color: rgba(45, 179, 208, 1);
  font-size: 30px;

  line-height: 30px;
  align-self: flex-start;
  max-width: 649px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .desc1 {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;

  line-height: 16px;
  margin-top: 29px;
  align-self: flex-start;
  /* max-width: 649px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}
.mod .entPcover2 {
  width: 628px;
  height: 460px;
  align-self: center;
}
 .entPcover3 {
  width: 628px;
  height: 350px;
}
#two{
  width:100%;
  background-color: #f8f8f8;
}
.mod .row {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1440px;
  margin: 0 auto;
}
.mod .block3 {
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: flex-start;
  width: 1440px;
  padding: 120px 12px;
}
.mod .titleWrapper1 {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1278px;
}
.mod .title2 {
  color: rgba(0, 0, 0, 1);
  font-size: 40px;

  line-height: 56px;
  align-self: flex-start;
  max-width: 1278px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .grid {
  display: flex;
  margin-top: 60px;
  justify-content: space-between;
  align-self: center;
  width: 1278px;
}
.mod .grid div{
  border-radius: 20px;
}
.mod .grid div:hover{
  background-size: 110% 110%;
}
.mod .colItem0 {
  width: 412px;
  height: 400px;
  display: flex;
  flex-direction: column;
  margin-left: 1px;
  justify-content: flex-start;
  align-self: center;
  padding: 240px 12px 62px;
  background-image: url(../../assets/img/enterprise/images/img_41.png);
  background-repeat: no-repeat;
  background-position: 0px 0px;
  background-size: 100% 100%;
  background-origin: padding-box;
  transition:all 1s;
}
.mod .wordWrapper {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 334px;
}
.mod .word {
  color: rgba(255, 255, 255, 1);
  font-size: 20px;

  line-height: 28px;
  align-self: flex-start;
  max-width: 334px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .detail {
  color: rgba(255, 255, 255, 1);
  font-size: 16px;

  line-height: 30px;
  align-self: flex-start;
  max-width: 334px;

  margin: 40px 0 0 27px;
}
.mod .colItem1 {
  width: 412px;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: center;
  padding: 240px 12px 62px;
  background-image: url(../../assets/img/enterprise/images/img_42.png);
  background-repeat: no-repeat;
  background-position: 0px 0px;
  background-size: 100% 100%;
  background-origin: padding-box;
  transition:all 1s;

}
.mod .tagWrapper {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 334px;
}
.mod .tag1 {
  color: rgba(255, 255, 255, 1);
  font-size: 20px;

  line-height: 28px;
  align-self: flex-start;
  max-width: 334px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .detail1 {
  color: rgba(255, 255, 255, 1);
  font-size: 16px;

  line-height: 30px;
  align-self: flex-start;
  max-width: 334px;

  margin: 40px 0 0 27px;
}
.mod .colItem2 {
  width: 412px;
  height: 400px;
  display: flex;
  flex-direction: column;
  margin-right: 1px;
  justify-content: flex-start;
  align-self: center;
  padding: 240px 12px 62px;
  background-image: url(../../assets/img/enterprise/images/img_43.png);
  background-repeat: no-repeat;
  background-position: 0px 0px;
  background-size: 100% 100%;
  background-origin: padding-box;
  transition:all 1s;
}
.mod .organizationWrapper {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 334px;
}
.mod .organization {
  color: rgba(255, 255, 255, 1);
  font-size: 20px;

  line-height: 28px;
  align-self: flex-start;
  max-width: 334px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .detail2 {
  color: rgba(255, 255, 255, 1);
  font-size: 16px;

  line-height: 30px;
  align-self: flex-start;
  max-width: 334px;

  margin: 40px 0 0 27px;
}
.mod .row1 {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1440px;
}
.mod .block4 {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: flex-start;
  width: 1440px;
  padding: 120px 12px;
}
.mod .captionWrapper {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1278px;
}
.mod .caption2 {
  color: rgba(0, 0, 0, 1);
  font-size: 40px;

  line-height: 56px;
  align-self: flex-start;
  max-width: 1278px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .container3 {
  display: flex;
  margin-top: 60px;
  justify-content: flex-start;
  align-self: center;
  width: 1278px;
}
.mod .wrapper2 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: center;
  position: relative;
  height: 353px;
  width: 650px;
}
.mod .group1 {
  display: flex;
  justify-content: space-between;
  align-self: flex-start;
  width: 354px;
  &.en{
    width: 542px;
    .span{
      font-size: 16px !important;
    }
  }
}
.mod .group1 span{
  cursor: pointer;
}
.mod .tag2 {
  color: rgba(45, 179, 208, 1);
  font-size: 18px;

  line-height: 26px;
  align-self: center;
  white-space: nowrap;
}
.mod .label1 {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  cursor: pointer;
  line-height: 26px;
  align-self: center;
  white-space: nowrap;
}
.mod .word1 {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;

  line-height: 26px;
  align-self: center;
  white-space: nowrap;
}
.mod .article {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  margin-top: 47px;
  align-self: flex-start;
  width: 512px;
  min-height: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  webkit-line-clamp: 3;
  webkit-box-orient: vertical;
  white-space: normal;
  margin-bottom: 30px;
}
.mod .iconItem0 {
  width: 22px;
  height: 23px;
  position: absolute;
  left: 2px;
  bottom: 158px;
}

.mod .view {
  display: flex;
  justify-content: space-between;
  align-self: center;
  position: relative;
  height: 30px;
  width: 190px;
}
.mod .tag3 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  align-self: center;
  white-space: nowrap;
}
.mod .icon1 {
  width: 22px;
  height: 23px;
  position: absolute;
  right: 34px;
  bottom: 3px;
}
.mod .tag4 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  align-self: center;
  white-space: nowrap;
  position: relative;
    left: 20px;
}
.mod.isEn .tag4{
  left: 60px;
}
.mod .icon2 {
  width: 22px;
  height: 23px;
  position: absolute;
  left: 266px;
  bottom: 3px;
}
.isEn .icon2 {
  left: 326px;
}
.mod .icon3 {
  width: 22px;
  height: 23px;
  position: absolute;
  right: 150px;
  bottom: 3px;
}
.mod .tag5 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  margin-right: 86px;
  align-self: center;
  white-space: nowrap;
}
.mod .tag5_1 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  margin-right: 86px;
  align-self: center;
  white-space: nowrap;
  position: relative;
    left: 50px;
}
.mod.isEn .tag5_1 {
  left: -51px;
}
.mod .iconItem1 {
  width: 22px;
  height: 23px;
  position: absolute;
  left: 2px;
  bottom: 110px;
}
.mod .groupItem11 {
  width: 586px;
  height: 30px;
  display: flex;
  margin: 20px 0 0 30px;
  justify-content: flex-start;
  align-self: center;
  position: relative;

}
.mod .info {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  align-self: center;
  white-space: nowrap;

}
.mod .icon4 {
  width: 22px;
  height: 23px;
  position: absolute;
  left: 134px;
  bottom: 3px;
}
.mod .labelItem0 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  margin-left: 84px;
  align-self: center;
  white-space: nowrap;
}
.mod.isEn .labelItem0{
  margin-left: 40px;
}
.mod .icon5 {
  width: 22px;
  height: 23px;
  position: absolute;
  left: 266px;
  bottom: 3px;
}
.isEn .icon5,.isEn.mod .icon8 {
  left:326px
}
.mod .labelItem1 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  margin-left: 72px;
  align-self: center;
  white-space: nowrap;
}
.mod.isEn .labelItem1{
  margin-left: 42px;
}
.mod .icon6 {
  width: 22px;
  height: 23px;
  position: absolute;
  right: 151px;
  bottom: 3px;
}
.mod .labelItem2 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  margin-left: 92px;
  align-self: center;
  white-space: nowrap;
}
.mod .iconItem2 {
  width: 22px;
  height: 23px;
  position: absolute;
  left: 2px;
  bottom: 58px;
}
.mod .groupItem21 {
  width: 586px;
  height: 30px;
  display: flex;
  margin: 20px 0 0 30px;
  justify-content: flex-start;
  align-self: center;
  position: relative;
}
.mod .word2 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  align-self: center;
  white-space: nowrap;

}
.mod .icon7 {
  width: 22px;
  height: 23px;
  position: absolute;
  left: 134px;
  bottom: 3px;
}
.mod .icon8 {
  width: 22px;
  height: 23px;
  position: absolute;
  left: 266px;
  bottom: 3px;
}
.mod .label2 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  line-height: 30px;
  margin-left: 76px;
  align-self: center;
  white-space: nowrap;
}
.mod .label2_1 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;

  line-height: 30px;
  margin-left: 110px;
  align-self: center;
  white-space: nowrap;
}
.mod.isEn .label2_1{
  margin-left: 34px;
}
.mod .banner {
  width: 626px;
  height: 353px;
  align-self: center;
  border-radius: 20px;
}
.mod .row2 {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1440px;
}
.mod .block5 {
  width: 1440px;
  height: 700px;
  background-image:
    url(../../assets/img/enterprise/images/img_46.webp);
  background-repeat: no-repeat, no-repeat, no-repeat;
  /* background-position: 1077px 587px, 0px 587px, 0px 0px; 左右格子 */
  background-size:  100% 100%;
  display: flex;
  /* flex-direction: column; */
  /* justify-content: flex-start; */
  /* align-self: flex-start; */
  padding: 0px 0 0px 0px;
  background-origin: padding-box;
}


.wrapper4.swiper-slide.swiper-slide-prev{
  margin-bottom: 30px;
}
.swiper-slide-shadow-top{
  border-radius:20px !important;
}
.mod .organization1 {
  color: rgba(255, 255, 255, 1);
  font-size: 30px;
  line-height: 60px;
  /* align-self: center; */
  width: 870px;
  /* height: 120px; */
  text-overflow: ellipsis;
  webkit-line-clamp: 2;
  webkit-box-orient: vertical;
  white-space: normal;
  width: 590px;
  font-size: 32px;
    font-weight: normal;
    line-height: 60px;
    width: 590px;
}
.mod .container4 {
  display: flex;
  margin-top: 60px;
  line-height: 48px;
  /* align-self: center; */
  /* width: 870px; */
}
.mod .tagWrapper1 {
  background-color: #2db3d0;
  margin-left: 166px;
  text-align: center;
  width: 200px;
  border-radius: 10px;
}
.mod .tag6 {
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  margin-right: 2px;
  align-self: flex-start;
  max-width: 172px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .container5 {
  display: flex;
  /* justify-content: flex-start; */
  /* align-self: flex-start; */
  /* width: 1825px; */
  /* margin: 47px 0 0 -188px; */
}
.mod .wrapper3 {
  display: flex;
  justify-content: space-between;
  align-self: flex-end;
  margin-bottom: 111px;
  width: 553px;

}
.mod .articleWrapper {
  display: flex;
  justify-content: flex-start;
  align-self: flex-end;
  height: 150px;
  opacity: 0.3;
}
.mod .article1 {
  color: rgba(255, 255, 255, 1);
  font-size: 16px;

  line-height: 30px;
  align-self: flex-start;
  width: 521px;
  height: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  webkit-line-clamp: 5;
  webkit-box-orient: vertical;
  white-space: normal;
}
.mod .group2 {
  display: flex;
  justify-content: flex-start;
  align-self: flex-end;
  margin-bottom: 43px;
  cursor: pointer;
}
.mod .icon9 {
  width: 16px;
  height: 29px;
  align-self: flex-start;
}
.mod .wrapper4 {
  margin-left: 55px;
  width: 601px;
 
  background: #FFFFFF;
  border-radius: 20px;
  height:400px;
  overflow-y: hidden;
  
  .slide-con{
    max-height:400px;
    overflow-y: scroll;
    padding:30px 40px 40px 40px;
  }
}
.mod .group3{
  width: 100%;
  height: 48px;
  background-repeat: no-repeat;
  background-size: 48px 48px;
  padding:0 0 74px 58px;
  border-bottom: 1px solid #2DB3D0;
}
.mod .people1{
  background-image: url("../../assets/img/people1.png");
}
.mod .people2{
  background-image: url("../../assets/img/people2.png");
}

.mod .people3{
  background-image: url("../../assets/img/people3.png");
}

.mod .people4{
  background-image: url("../../assets/img/people4.png");
}

.mod .people5{
  background-image: url("../../assets/img/people5.png");
}

.mod .people6{
  background-image: url("../../assets/img/people6.png");
}

.mod .people7{
  background-image: url("../../assets/img/people7.png");
}

.mod .people7{
  background-image: url("../../assets/img/people8.png");
}
.mod .people9{
  background-image: url("../../assets/img/people9.png");
}
.mod .people10{
  background-image: url("../../assets/img/people10.png");
}


.mod .group3 span{
  display:block;
}
.mod .group3 .name1{
  font-size: 18px;
  color: #2DB3D0;
  margin-bottom: 4px;
  padding-top: 12px;

}
.mod .group3  .nickName1{
  font-size: 12px;
  color: #000000;
}
.mod  .content{
  padding-top: 20px;
  font-size: 16px;
font-weight: normal;
line-height: 32px;
text-align: justify; /* 浏览器可能不支持 */
letter-spacing: 0em;
/* 字1 */
color: #000000;

}
.mod .article2 {
  color: rgba(255, 255, 255, 1);
  font-size: 16px;

  line-height: 30px;
  align-self: center;
  margin-right: 2px;
  width: 521px;
  height: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  webkit-line-clamp: 5;
  webkit-box-orient: vertical;
  white-space: normal;
}
.mod .nickName {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;

  line-height: 30px;
  align-self: flex-start;
  max-width: 523px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 40px 0 0 27px;
}
.mod .wrapper5 {
  padding-bottom: 1px;
  display: flex;
  justify-content: space-between;
  align-self: flex-end;
  height: 221px;
  width: 551px;
  margin: 0 0 40px 65px;

}
.mod .group4 {
  display: flex;
  justify-content: flex-start;
  align-self: flex-start;
  margin-top: 90px;
  cursor: pointer;
}
.mod .icon10 {
  width: 16px;
  height: 29px;
  align-self: flex-start;
}
.mod .group5 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: flex-start;
  height: 220px;
}
.mod .article3 {
  color: rgba(255, 255, 255, 1);
  font-size: 16px;

  line-height: 30px;
  align-self: center;
  width: 521px;
  height: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  webkit-line-clamp: 5;
  webkit-box-orient: vertical;
  white-space: normal;
  opacity: 0.3;
}
.mod .name {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;

  line-height: 30px;
  margin-top: 40px;
  align-self: flex-start;
  max-width: 521px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .main {
  display: flex;
  flex-direction: column;
  margin-top: 120px;
  justify-content: flex-start;
  align-self: center;
  width: 1440px;
}
.mod .titleWrapper2 {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1372px;
}
.mod .title3 {
  color: rgba(0, 0, 0, 1);
  font-size: 40px;

  line-height: 56px;
  margin-left: 47px;
  align-self: flex-start;
  max-width: 1278px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod .block6 {
  display: flex;
  margin-top: 60px;
  justify-content: flex-start;
  align-self: center;
  width: 1372px;
  overflow: hidden;

}
.imgBox1{
  width: 1280px;
  overflow: hidden;
  display: flex;
  border-radius: 20px;
  height:490px
}
.imgBox1 img{
  margin: 0 10px;
  width: 520px;
  height: 390px;
  border-radius: 20px;
}
.block6 .imgBox{
  position: relative;
    margin: 0 auto;
    /* padding-left: 30px; */
    display: flex;
    width:1276px;
}
.mod .icon11 {
  align-self: center;
  margin: 1px 20px 0 1px;
  width: 16.5px;
  height: 29px;
  cursor: pointer;
}
.mod .banner1 {
  width: 520px;
  height: 414px;
  /* margin-left: 0px; */
  align-self: center;
  border-radius: 20px;
}
.main img {
  height: 414px;
  align-self: center;
   border-radius: 20px;
}
.mod .itemLong {
  width: 304px;
  height: 414px;
  margin-left: 20px;
  align-self: center;
  border-radius: 20px;
}
.mod .icon12 {
  width: 17px;
  height: 17px;
  align-self: center;
  margin: 1px 0 0 31px;
  width: 16.5px;
height: 29px;
cursor: pointer;

}
.mod .footer {
  display: flex;
  flex-direction: column;
  margin-top: 306px;
  justify-content: flex-start;
  align-self: center;
  width: 1440px;
}
.mod .block7 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: center;
  position: relative;
  width: 1440px;
}
.mod .container6 {
  display: flex;
  justify-content: space-between;
  align-self: center;
  width: 1276px;
}
.mod .actionBg {
  width: 162px;
  height: 72px;
  align-self: flex-end;
}
.mod .wrapper6 {
  display: flex;
  justify-content: flex-start;
  align-self: flex-end;
  margin-bottom: 32px;
  position: relative;
}
.mod .media {
  width: 40px;
  height: 40px;
  align-self: flex-start;
}
.mod .figure {
  width: 18px;
  height: 17px;
  position: absolute;
  left: 50%;
  top: 11px;
  transform: translateX(-50%);
}
.mod .icon13 {
  width: 17px;
  height: 17px;
  align-self: flex-start;
  margin: 36px 0 0 1337px;
}
.mod .icon14 {
  width: 21px;
  height: 16px;
  align-self: flex-end;
  margin: 23px 83px 0 0;
}
.mod .icon15 {
  width: 14px;
  height: 14px;
  position: absolute;
  right: 87px;
  bottom: -4px;
  z-index: 1;
}
.mod .dot2 {
  width: 6px;
  height: 7px;
  align-self: flex-start;
  z-index: 2;
  margin: 25px 0 0 1343px;
}
.mod .descWrapper {
  background-color: #222d44;
  display: flex;
  margin-top: 112px;
  justify-content: center;
  align-self: center;
  width: 1440px;
  padding: 20px 12px;
}
.mod .desc2 {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;

  line-height: 20px;
  margin-right: 2px;
  align-self: flex-start;
  max-width: 1412px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
::-webkit-scrollbar {
  width: 8px;
  height: 50px;
  }
  ::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: rgba(0,0,0,.5);height: 50px;
  }


</style>

<style src="./index.css" scoped/>



// WEBPACK FOOTER //
// src/view/Enterprise/index.vue